define(
    'viewmodels/upload',[
        "viewmodels/ViewModelNotification",
        "i19n!i19n/strings",
        "services/config",
        "plugins/router",
        "providers/dataprovider",
        "dropzone",
        "viewmodels/controller",
        "extensions/file.extensions"
    ],
    function (ViewModelNotification, i19n, config, router, dataProvider, Dropzone, shell, fileExt) {
        var myDropzone = null;

        var vm = new ViewModelNotification(
        {
            id: '',
            i19n: i19n,
            linkId: '',            
            isUploadDocument: ko.observable(false),
            isVisible: ko.observable(false),
            title: ko.observable(''),
            subject: ko.observable(''),
            message: ko.observable(''),
            expiry: ko.observable(),
            isExpired: ko.observable(false),
            footer: ko.observable(''),
            documents: ko.observableArray([])
        });

        vm.activate = function (p) {
            if (!(window.File && window.FileReader && window.FileList && window.Blob)) {
                alert("The file APIs not fully supported in this browser");

                router.navigate("login");

                return false;
            }

            vm.linkId = p.substring(3, p.length);

            vm.subject("");
            vm.title("");
            vm.message("");
            vm.expiry("");
            vm.isVisible(true);

            return loadData(vm.linkId);
        };
        vm.attached = function () {
            var options = {
                url: "#",
                paramName: "file",
                maxFilesize: config.maxFilesizeUpload,
                accept: function (file, done) {
                    done();
                },
                uploadMultiple: false,
                autoProcessQueue: true,
                parallelUploads: 5,
                method: "PUT",

                init: function () {
                    this.on("processing", function (file, done) {                       
                        dataProvider.signurl
                        .addShareFolderFile({
                            action: "adddocumentstart",
                            linkId: vm.linkId,
                            title: file.filename,
                            extension: file.fileext
                        })
                        .done(function (data) {
                            file.fileurl = data.repositoryPutUrl;
                            file.revision = data.revision;
                            file.documentId = data.documentId;

                            done(file);
                        })
                        .fail(function (e) {
                            console.error(e);

                            done(file);
                            myDropzone.cancelUpload(file);
                        });
                    });
                    this.on("addedfile", function (file) {
                        try {
                            var rx = /(?:\.([^.]+))?$/;

                            file.filename = file.name;
                            file.fileext = rx.exec(file.name)[1];

                            if (file.filename !== file.fileext) {
                                file.filename = file.filename.substring(0, file.filename.length - file.fileext.length - 1);
                            }

                        } catch (ex) { }

                        file.fileretry = 0;
                        
                        vm.isUploadDocument(myDropzone.files.length > 0);

                        vm.eventBroker.trigger(vm, vm.config.events.header.show, { isShow: false });
                    });
                    this.on("removedfile", function (file) {
                        vm.isUploadDocument(myDropzone.files.length > 0);
                    });
                    this.on("sending", function (file, xhr, formData) {
                        xhr.setRequestHeader('content-type', ' ');
                    });
                    this.on("complete", function (file) {
                        //if (myDropzone.getUploadingFiles().length == 0) {
                        //    vm.eventBroker.trigger(vm, vm.config.events.header.show, { isShow: true });
                        //}
                    });
                    this.on("error", function (file, response) {
                        if (file.accepted) {
                            file.fileretry++;
                            if (file.fileretry < 4) {
                                setTimeout(function () {
                                    myDropzone.processFile(file);
                                }, 10000 * file.fileretry);
                            }
                        }

                        console.error(response);
                    });
                    this.on("maxfilesexceeded", function () {
                        vm.notify('error', i19n.to.maxfileexceeded);
                    });
                    this.on("success", function (file, response) {                        
                        dataProvider.signurl
                        .addShareFolderFile({
                            action: "adddocumentcomplete",
                            documentId: file.documentId,
                            linkId: vm.linkId
                        })
                        .done(function (data) {
                            myDropzone.removeFile(file);

                            if (myDropzone.getUploadingFiles().length == 0) {
                                //vm.isVisible(false);

                                //window.location.reload();

                                shell.isBusy(true);

                                loadData(vm.linkId)
                                .always(function () {
                                    shell.isBusy(false);
                                });
                            }
                        })
                        .fail(function (e) {
                            console.error(e);

                            myDropzone.cancelUpload(file);
                        });
                    });
                    this.on("totaluploadprogress", function (uploadProgress, totalBytes, totalBytesSent) {
                        //console.warn(totalBytesSent + " of " + totalBytes + " (" + uploadProgress + " %)");
                    });                    
                },
                addRemoveLinks: true,
                dictDefaultMessage: '<span class="bigger-150 bolder">Drop a file</span> to upload \
            	                        <span class="smaller-80 grey">(or click)</span> <br /> \
            	                        <i class="fa fa-cloud-upload blue fa-3x"></i> <br /> \
                                        <span class="smaller-60 grey">Maximum size per file is ' + config.maxFilesizeUpload + 'MB</span>',
                dictResponseError: 'Error while uploading file!',
                previewTemplate: "<div class=\"dz-preview dz-file-preview\">\n  <div class=\"dz-details\">\n    <div class=\"dz-filename\"><span data-dz-name></span></div>\n    <div class=\"dz-size\" data-dz-size></div>\n    <img data-dz-thumbnail />\n  </div>\n  <div class=\"progress progress-small progress-striped active\"><div class=\"progress-bar progress-bar-info\" data-dz-uploadprogress></div></div>\n  <div class=\"dz-success-mark\"><span></span></div>\n  <div class=\"dz-error-mark\"><span></span></div>\n  <div class=\"dz-error-message\"><span data-dz-errormessage></span></div>\n</div>"
            };

            try {

                myDropzone = new Dropzone(".dropzone", options);

            } catch (e) {
                alert('Dropzone.js does not support older browsers!');
            }
        };
        vm.explore = function () {
            if (sessionStorage.__url) {
                window.location.href = sessionStorage.__url;
            } else {
                router.navigate("explorer");
            }
            //router.navigate("explorer");
        };
        vm.clickHelp = function () {
            window.open('http://help.fileplan.com');
        };
        vm.clickDownload = function (data) {
            window.location = getUrl("documentshares/instancedocument/" + config.instanceCode + "/", data.link);

            return false;
        };
        //vm.addDocuments = ko.asyncCommand({
        //    canExecute: function (isExecuting) {
        //        return !isExecuting && vm.isUploadDocument();
        //    },
        //    execute: function (complete) {
        //        vm.isUploadDocument(false);
        //        vm.clearNotifications();

        //        myDropzone.processQueue();
        //        myDropzone.options.autoProcessQueue = true;

        //        complete();
        //    }
        //});
        vm.clickCancel = function () {
            if (myDropzone) {
                if (myDropzone.getUploadingFiles().length > 0) {
                    location.reload();
                    return;
                }

                myDropzone.removeAllFiles(true);
            }            

            //window.location.hash = "#explorer";
            vm.eventBroker.trigger(vm, vm.config.events.header.show, { isShow: true });

            window.location.reload();
        };

        return vm;

        function loadData(id) {
            var d = $.Deferred();

            dataProvider.folders
            .getFolderShareById(id)
            .done(function (data) {
                var exp = data.expiryDate !== null ? moment(data.expiryDate).format("D MMMM YYYY h:mm a") : null;
                var isExpired = false;

                if (exp !== null) {
                    var now = moment();
                    var before = moment(exp);
                    //var before = moment("2014-08-31T00:00:00.0000+10:00");

                    isExpired = moment(before).isBefore(now);
                }
                
                data.folderShareDocuments = data.folderShareDocuments == null ? [] : data.folderShareDocuments;

                data.folderShareDocuments = _.map(data.folderShareDocuments, function (itm) {
                    itm.uploadDate = moment(itm.uploadDate).format("D MMMM YYYY h:mm a");
                    itm.icon = fileExt.getApplicationTypeIcon(itm.extension);
                    return itm;
                });

                vm.subject(data.subject);
                vm.title(data.shareDisplayTitle);
                vm.message(data.message);
                vm.expiry(exp);
                vm.isExpired(isExpired);
                vm.footer(data.footer);
                vm.documents(data.folderShareDocuments);

                d.resolve(true);
            })
            .fail(function (e) {
                e.stopPropagation = true;

                vm.isExpired(true);

                d.resolve(false);
            });

            return d.promise();
        }

        function getUrl(action, id) {
            return config.webApiUrl + action + id;
        }
    }
);
